import React, { useState, useEffect, useCallback } from 'react';

const API = '/api/superadmin';

const getToken = () => localStorage.getItem('hs_admin_token');
const setToken = (t) => localStorage.setItem('hs_admin_token', t);
const clearToken = () => localStorage.removeItem('hs_admin_token');

async function apiFetch(path, opts = {}) {
  const res = await fetch(`${API}${path}`, {
    ...opts,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`,
      ...(opts.headers || {}),
    },
    body: opts.body ? JSON.stringify(opts.body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || 'Hitilafu ya seva');
  return data;
}

const fmt = (n) => Number(n || 0).toLocaleString('sw-TZ');
const fmtDate = (d) => d ? new Date(d).toLocaleDateString('sw-TZ', { day: '2-digit', month: 'short', year: 'numeric' }) : '—';
const trialStatus = (shop) => {
  if (shop.plan === 'paid') return { label: 'Paid', color: '#10b981', bg: '#d1fae5' };
  if (shop.plan === 'free') return { label: 'Free', color: '#6366f1', bg: '#e0e7ff' };
  if (shop.plan === 'suspended') return { label: 'Suspended', color: '#ef4444', bg: '#fee2e2' };
  const days = Math.ceil((new Date(shop.trial_ends_at) - Date.now()) / 86400000);
  if (days < 0) return { label: 'Trial Ended', color: '#ef4444', bg: '#fee2e2' };
  if (days <= 3) return { label: `Trial: siku ${days}`, color: '#f59e0b', bg: '#fef3c7' };
  return { label: `Trial: siku ${days}`, color: '#0891b2', bg: '#cffafe' };
};

const S = {
  root: { minHeight: '100vh', background: '#0f172a', color: '#e2e8f0', fontFamily: "'Inter', 'Segoe UI', system-ui, sans-serif" },
  loginWrap: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg,#0f172a 0%,#1e293b 100%)' },
  loginCard: { width: 380, padding: '40px 36px', background: '#1e293b', borderRadius: 16, border: '1px solid #334155', boxShadow: '0 24px 48px rgba(0,0,0,.5)' },
  loginLogo: { textAlign: 'center', marginBottom: 32 },
  logoText: { fontSize: 22, fontWeight: 700, color: '#38bdf8', letterSpacing: '-0.5px' },
  logoSub: { fontSize: 11, color: '#64748b', marginTop: 4, letterSpacing: 2, textTransform: 'uppercase' },
  label: { display: 'block', fontSize: 11, color: '#94a3b8', marginBottom: 6, letterSpacing: 1, textTransform: 'uppercase' },
  input: { width: '100%', padding: '10px 14px', background: '#0f172a', border: '1px solid #334155', borderRadius: 8, color: '#e2e8f0', fontSize: 14, outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit' },
  btn: (color) => ({ padding: '11px 20px', background: color || '#0ea5e9', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit', letterSpacing: 0.3 }),
  btnSm: (color) => ({ padding: '6px 12px', background: color || '#0ea5e9', color: '#fff', border: 'none', borderRadius: 6, fontSize: 11, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit', letterSpacing: 0.3, whiteSpace: 'nowrap' }),
  btnGhost: { padding: '6px 12px', background: 'transparent', color: '#94a3b8', border: '1px solid #334155', borderRadius: 6, fontSize: 11, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' },
  errBox: { background: '#450a0a', border: '1px solid #7f1d1d', borderRadius: 8, padding: '10px 14px', color: '#fca5a5', fontSize: 13, marginBottom: 16 },
  header: { height: 56, background: '#1e293b', borderBottom: '1px solid #334155', display: 'flex', alignItems: 'center', padding: '0 24px', gap: 16, position: 'sticky', top: 0, zIndex: 100 },
  headerTitle: { fontSize: 13, fontWeight: 700, color: '#38bdf8', letterSpacing: 1, flex: 1 },
  main: { padding: '24px', maxWidth: 1400, margin: '0 auto' },
  statsGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 14, marginBottom: 28 },
  statCard: { background: '#1e293b', border: '1px solid #334155', borderRadius: 12, padding: '18px 20px' },
  statVal: { fontSize: 28, fontWeight: 700, color: '#f1f5f9', lineHeight: 1 },
  statLabel: { fontSize: 11, color: '#64748b', marginTop: 6, letterSpacing: 0.8, textTransform: 'uppercase' },
  tableWrap: { background: '#1e293b', border: '1px solid #334155', borderRadius: 12, overflow: 'hidden' },
  tableHeader: { padding: '16px 20px', display: 'flex', alignItems: 'center', gap: 12, borderBottom: '1px solid #334155', flexWrap: 'wrap' },
  tableTitle: { fontSize: 13, fontWeight: 700, color: '#f1f5f9', flex: 1, letterSpacing: 0.3 },
  searchInput: { padding: '8px 14px', background: '#0f172a', border: '1px solid #334155', borderRadius: 8, color: '#e2e8f0', fontSize: 12, outline: 'none', width: 220, fontFamily: 'inherit' },
  table: { width: '100%', borderCollapse: 'collapse' },
  th: { padding: '10px 16px', textAlign: 'left', fontSize: 10, color: '#64748b', letterSpacing: 1.2, textTransform: 'uppercase', borderBottom: '1px solid #1e293b', background: '#0f172a', fontWeight: 600 },
  td: { padding: '14px 16px', fontSize: 12, borderBottom: '1px solid #1e293b', verticalAlign: 'middle' },
  badge: (color, bg) => ({ display: 'inline-block', padding: '3px 8px', borderRadius: 4, fontSize: 10, fontWeight: 700, letterSpacing: 0.5, color, background: bg }),
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,.7)', zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 },
  modal: { background: '#1e293b', border: '1px solid #334155', borderRadius: 16, width: '100%', maxWidth: 540, padding: '28px 28px 24px', boxShadow: '0 32px 64px rgba(0,0,0,.6)' },
  modalTitle: { fontSize: 16, fontWeight: 700, color: '#f1f5f9', marginBottom: 20 },
  row: { display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' },
  successBox: { background: '#052e16', border: '1px solid #166534', borderRadius: 8, padding: '12px 16px', color: '#86efac', fontSize: 13, marginTop: 12 },
  tempPwd: { background: '#0f172a', border: '1px solid #334155', borderRadius: 6, padding: '10px 14px', fontFamily: "'DM Mono', monospace", fontSize: 18, fontWeight: 700, color: '#fbbf24', letterSpacing: 2, textAlign: 'center', marginTop: 8 },
  select: { padding: '8px 12px', background: '#0f172a', border: '1px solid #334155', borderRadius: 8, color: '#e2e8f0', fontSize: 12, fontFamily: 'inherit', outline: 'none' },
};

function AdminLogin({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [paymentShop, setPaymentShop] = useState(null);
  const [showPayments, setShowPayments] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      const res = await fetch(`${API}/ingia`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!data.token) throw new Error(data.error || 'Imeshindwa kuingia');
      setToken(data.token);
      onLogin(data.admin);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={S.loginWrap}>
      <div style={S.loginCard}>
        <div style={S.loginLogo}>
          <div style={S.logoText}>HesabuSmart</div>
          <div style={S.logoSub}>Super Admin Panel</div>
        </div>
        {error && <div style={S.errBox}>{error}</div>}
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 16 }}>
            <label style={S.label}>Email</label>
            <input style={S.input} type="email" value={email} onChange={e => setEmail(e.target.value)} required autoFocus />
          </div>
          <div style={{ marginBottom: 24 }}>
            <label style={S.label}>Nywila</label>
            <input style={S.input} type="password" value={password} onChange={e => setPassword(e.target.value)} required />
          </div>
          <button style={{ ...S.btn(), width: '100%' }} disabled={loading}>
            {loading ? 'Inaingia...' : 'Ingia'}
          </button>
        </form>
      </div>
    </div>
  );
}

function ShopModal({ shop, onClose, onRefresh }) {
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState('');
  const [tempPwd, setTempPwd] = useState('');
  const [trialDays, setTrialDays] = useState(14);
  const [notes, setNotes] = useState(shop.notes || '');
  const [plan, setPlan] = useState(shop.plan || 'trial');
  const status = trialStatus(shop);

  const action = async (fn) => {
    setLoading(true); setMsg(''); setTempPwd('');
    try { await fn(); onRefresh(); }
    catch (e) { setMsg('Hitilafu: ' + e.message); }
    finally { setLoading(false); }
  };

  const toggleActive = () => action(async () => {
    await apiFetch(`/duka/${shop.id}/hali`, { method: 'PATCH', body: { is_active: !shop.is_active } });
    setMsg(shop.is_active ? 'Duka limezimwa' : 'Duka limewashwa');
  });

  const extendTrial = () => action(async () => {
    const r = await apiFetch(`/duka/${shop.id}/jaribio`, { method: 'PATCH', body: { siku: trialDays } });
    setMsg(`Jaribio limepanuliwa hadi ${fmtDate(r.trial_ends_at)}`);
  });

  const changePlan = () => action(async () => {
    await apiFetch(`/duka/${shop.id}/mpango`, { method: 'PATCH', body: { plan } });
    setMsg(`Mpango: ${plan}`);
  });

  const resetPassword = () => action(async () => {
    const r = await apiFetch(`/duka/${shop.id}/weka-nywila`, { method: 'POST' });
    setTempPwd(r.temp_password);
    setMsg('Nywila mpya ya muda:');
  });

  const saveNotes = () => action(async () => {
    await apiFetch(`/duka/${shop.id}/maelezo`, { method: 'PATCH', body: { notes } });
    setMsg('Maelezo yamehifadhiwa');
  });

  return (
    <div style={S.overlay} onClick={e => e.target === e.currentTarget && onClose()}>
      <div style={S.modal}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20 }}>
          <div>
            <div style={S.modalTitle}>{shop.name}</div>
            <div style={{ fontSize: 12, color: '#64748b' }}>{shop.owner_name} · {shop.email}</div>
            {shop.phone && <div style={{ fontSize: 12, color: '#64748b' }}>{shop.phone}</div>}
          </div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: '#64748b', fontSize: 20, cursor: 'pointer' }}>x</button>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 10, marginBottom: 20 }}>
          {[['Mauzo', shop.jumla_mauzo], ['Mapato', 'TZS ' + fmt(shop.jumla_mapato)], ['Bidhaa', shop.jumla_bidhaa], ['Watumiaji', shop.jumla_watumiaji]].map(([l, v]) => (
            <div key={l} style={{ background: '#0f172a', borderRadius: 8, padding: '10px 12px', border: '1px solid #334155' }}>
              <div style={{ fontSize: 13, fontWeight: 700, color: '#f1f5f9' }}>{v}</div>
              <div style={{ fontSize: 10, color: '#64748b', marginTop: 2 }}>{l}</div>
            </div>
          ))}
        </div>
        <div style={{ ...S.row, marginBottom: 20 }}>
          <span style={S.badge(status.color, status.bg)}>{status.label}</span>
          <span style={S.badge(shop.is_active ? '#10b981' : '#ef4444', shop.is_active ? '#d1fae5' : '#fee2e2')}>
            {shop.is_active ? 'Active' : 'Inactive'}
          </span>
          <span style={{ fontSize: 11, color: '#64748b', marginLeft: 'auto' }}>Sajiliwa: {fmtDate(shop.created_at)}</span>
        </div>
        <div style={{ borderTop: '1px solid #334155', paddingTop: 16, display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div style={{ ...S.row, justifyContent: 'space-between' }}>
            <span style={{ fontSize: 12, color: '#94a3b8' }}>Hali ya duka</span>
            <button onClick={toggleActive} disabled={loading} style={S.btnSm(shop.is_active ? '#ef4444' : '#10b981')}>
              {shop.is_active ? 'Zima Duka' : 'Washa Duka'}
            </button>
          </div>
          <div style={{ ...S.row, justifyContent: 'space-between' }}>
            <span style={{ fontSize: 12, color: '#94a3b8' }}>Panua jaribio</span>
            <div style={S.row}>
              <input type="number" value={trialDays} min={1} max={365} onChange={e => setTrialDays(Number(e.target.value))}
                style={{ ...S.input, width: 70, textAlign: 'center', padding: '6px 8px' }} />
              <span style={{ fontSize: 11, color: '#64748b' }}>siku</span>
              <button onClick={extendTrial} disabled={loading} style={S.btnSm('#0ea5e9')}>Panua</button>
            </div>
          </div>
          <div style={{ ...S.row, justifyContent: 'space-between' }}>
            <span style={{ fontSize: 12, color: '#94a3b8' }}>Badilisha mpango</span>
            <div style={S.row}>
              <select value={plan} onChange={e => setPlan(e.target.value)} style={S.select}>
                <option value="trial">Trial</option>
                <option value="paid">Paid</option>
                <option value="free">Free</option>
                <option value="suspended">Suspended</option>
              </select>
              <button onClick={changePlan} disabled={loading} style={S.btnSm('#6366f1')}>Hifadhi</button>
            </div>
          </div>
          <div style={{ ...S.row, justifyContent: 'space-between' }}>
            <div>
              <div style={{ fontSize: 12, color: '#94a3b8' }}>Weka nywila ya muda</div>
              <div style={{ fontSize: 10, color: '#475569' }}>Itumwa kwa mmiliki kwa simu</div>
            </div>
            <button onClick={resetPassword} disabled={loading} style={S.btnSm('#f59e0b')}>Weka Nywila</button>
          </div>
          <div>
            <div style={{ fontSize: 12, color: '#94a3b8', marginBottom: 6 }}>Maelezo ya ndani</div>
            <div style={S.row}>
              <textarea value={notes} onChange={e => setNotes(e.target.value)} rows={2}
                placeholder="Maelezo yoyote ya ndani kuhusu duka hili..."
                style={{ ...S.input, resize: 'vertical', flex: 1, fontSize: 12 }} />
              <button onClick={saveNotes} disabled={loading} style={S.btnSm('#64748b')}>Hifadhi</button>
            </div>
          </div>
        </div>
        {msg && (
          <div style={msg.startsWith('Hitilafu') ? S.errBox : S.successBox}>
            {msg}
            {tempPwd && <div style={S.tempPwd}>{tempPwd}</div>}
            {tempPwd && <div style={{ fontSize: 11, color: '#86efac', marginTop: 8, textAlign: 'center' }}>Iandike sasa. Inaonekana mara moja tu.</div>}
          </div>
        )}
      </div>
    </div>
  );
}


function PaymentModal({ shop, onClose, onSuccess }) {
  const [form, setForm] = useState({ kiasi: '', njia_malipo: 'mpesa', namba_rejea: '', namba_simu: '', miezi: 1, maelezo: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [paymentShop, setPaymentShop] = useState(null);
  const [showPayments, setShowPayments] = useState(false);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const submit = async () => {
    if (!form.kiasi || isNaN(form.kiasi) || Number(form.kiasi) <= 0) { setError('Weka kiasi sahihi'); return; }
    setLoading(true); setError('');
    try {
      const r = await apiFetch('/malipo', { method: 'POST', body: { shop_id: shop.id, ...form, kiasi: Number(form.kiasi), miezi: Number(form.miezi) } });
      onSuccess(r);
    } catch (e) { setError(e.message); }
    finally { setLoading(false); }
  };

  return (
    <div style={S.overlay} onClick={e => e.target === e.currentTarget && onClose()}>
      <div style={S.modal}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <div>
            <div style={S.modalTitle}>Rekodi Malipo</div>
            <div style={{ fontSize: 12, color: '#64748b' }}>{shop.name} · {shop.owner_name}</div>
          </div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: '#64748b', fontSize: 20, cursor: 'pointer' }}>x</button>
        </div>
        {error && <div style={{ ...S.errBox, marginBottom: 16 }}>{error}</div>}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <div>
              <label style={S.label}>Kiasi (TZS)</label>
              <input style={S.input} type="number" placeholder="5000" value={form.kiasi} onChange={e => set('kiasi', e.target.value)} />
            </div>
            <div>
              <label style={S.label}>Miezi</label>
              <select style={S.select} value={form.miezi} onChange={e => set('miezi', e.target.value)}>
                {[1,2,3,6,12].map(m => <option key={m} value={m}>{m} {m===1?'mwezi':'miezi'}</option>)}
              </select>
            </div>
          </div>
          <div>
            <label style={S.label}>Njia ya Malipo</label>
            <select style={{ ...S.select, width: '100%' }} value={form.njia_malipo} onChange={e => set('njia_malipo', e.target.value)}>
              <option value="mpesa">M-Pesa (Vodacom)</option>
              <option value="airtel">Airtel Money</option>
              <option value="tigopesa">Tigo Pesa</option>
              <option value="halopesa">HaloPesa</option>
              <option value="mix">Mix by Yas</option>
              <option value="selcom">Selcom</option>
              <option value="cash">Pesa Taslimu</option>
              <option value="nyingine">Nyingine</option>
            </select>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <div>
              <label style={S.label}>Namba ya Rejea</label>
              <input style={S.input} type="text" placeholder="ABC123XYZ" value={form.namba_rejea} onChange={e => set('namba_rejea', e.target.value)} />
            </div>
            <div>
              <label style={S.label}>Namba ya Simu</label>
              <input style={S.input} type="text" placeholder="0712345678" value={form.namba_simu} onChange={e => set('namba_simu', e.target.value)} />
            </div>
          </div>
          <div>
            <label style={S.label}>Maelezo (hiari)</label>
            <input style={S.input} type="text" placeholder="Maelezo yoyote..." value={form.maelezo} onChange={e => set('maelezo', e.target.value)} />
          </div>
          <button onClick={submit} disabled={loading} style={{ ...S.btn('#10b981'), width: '100%', marginTop: 4 }}>
            {loading ? 'Inahifadhi...' : 'Hifadhi Malipo'}
          </button>
        </div>
      </div>
    </div>
  );
}

function PaymentsPanel({ onClose }) {
  const [payments, setPayments] = useState([]);
  const [summary, setSummary] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiFetch('/malipo').then(d => { setPayments(d.payments); setSummary(d.summary); }).finally(() => setLoading(false));
  }, []);

  const njiaLabel = { mpesa:'M-Pesa', airtel:'Airtel', tigopesa:'Tigo', halopesa:'Halo', mix:'Mix', selcom:'Selcom', cash:'Taslimu', nyingine:'Nyingine' };

  return (
    <div style={S.overlay} onClick={e => e.target === e.currentTarget && onClose()}>
      <div style={{ ...S.modal, maxWidth: 780, maxHeight: '85vh', display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <div style={S.modalTitle}>Historia ya Malipo</div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: '#64748b', fontSize: 20, cursor: 'pointer' }}>x</button>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 10, marginBottom: 16 }}>
          {[['Malipo Yote', summary.jumla_malipo, '#38bdf8'],['Jumla Mapato', 'TZS ' + fmt(summary.jumla_mapato), '#10b981'],['Mwezi Huu', 'TZS ' + fmt(summary.mapato_mwezi), '#f59e0b']].map(([l,v,a]) => (
            <div key={l} style={{ background: '#0f172a', borderRadius: 8, padding: '12px 14px', border: '1px solid #334155', borderLeft: '3px solid ' + a }}>
              <div style={{ fontSize: 16, fontWeight: 700, color: a }}>{v || '—'}</div>
              <div style={{ fontSize: 10, color: '#64748b', marginTop: 4 }}>{l}</div>
            </div>
          ))}
        </div>
        <div style={{ overflowY: 'auto', flex: 1 }}>
          {loading ? <div style={{ textAlign: 'center', color: '#475569', padding: 40 }}>Inapakua...</div> : (
            <table style={S.table}>
              <thead>
                <tr>{['Duka','Kiasi','Njia','Rejea','Miezi','Tarehe','Iliandikwa Na'].map(h => <th key={h} style={S.th}>{h}</th>)}</tr>
              </thead>
              <tbody>
                {payments.length === 0 ? (
                  <tr><td colSpan={7} style={{ ...S.td, textAlign: 'center', color: '#475569', padding: 30 }}>Hakuna malipo bado</td></tr>
                ) : payments.map(p => (
                  <tr key={p.id}>
                    <td style={S.td}><div style={{ fontWeight: 600, color: '#f1f5f9', fontSize: 12 }}>{p.shop_name}</div><div style={{ fontSize: 10, color: '#475569' }}>{p.owner_name}</div></td>
                    <td style={S.td}><span style={{ fontWeight: 700, color: '#34d399', fontSize: 13 }}>TZS {fmt(p.kiasi)}</span></td>
                    <td style={S.td}><span style={S.badge('#0ea5e9','#0c4a6e')}>{njiaLabel[p.njia_malipo]||p.njia_malipo}</span></td>
                    <td style={S.td}><span style={{ fontSize: 11, color: '#94a3b8', fontFamily: 'monospace' }}>{p.namba_rejea||'—'}</span></td>
                    <td style={S.td}><span style={{ fontSize: 12, color: '#cbd5e1' }}>{p.miezi}m</span></td>
                    <td style={S.td}><span style={{ fontSize: 11, color: '#475569' }}>{fmtDate(p.created_at)}</span></td>
                    <td style={S.td}><span style={{ fontSize: 11, color: '#64748b' }}>{p.recorded_by||'—'}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}

export default function AdminPanel() {
  const [admin, setAdmin] = useState(null);
  const [shops, setShops] = useState([]);
  const [stats, setStats] = useState({});
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [showAddShop, setShowAddShop] = useState(false);
  const [addForm, setAddForm] = useState({jina_duka:'',jina_mmiliki:'',email:'',simu:'',mahali:'',password:'',plan:'trial'});
  const [addLoading, setAddLoading] = useState(false);
  const [addError, setAddError] = useState('');
  const [planFilter, setPlanFilter] = useState('');
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [selectedShop, setSelectedShop] = useState(null);
  const [error, setError] = useState('');
  const [paymentShop, setPaymentShop] = useState(null);
  const [showPayments, setShowPayments] = useState(false);
  const LIMIT = 20;

  useEffect(() => {
    if (getToken()) {
      apiFetch('/me').then(setAdmin).catch(() => clearToken());
    }
  }, []);

  const fetchShops = useCallback(async () => {
    if (!getToken()) return;
    setLoading(true); setError('');
    try {
      const params = new URLSearchParams({ page, limit: LIMIT, search, plan: planFilter });
      const data = await apiFetch(`/duka?${params}`);
      setShops(data.shops);
      setTotal(data.total);
      setStats(data.stats || {});
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, [page, search, planFilter]);

  useEffect(() => { if (admin) fetchShops(); }, [admin, fetchShops]);

  const logout = () => { clearToken(); setAdmin(null); setShops([]); };
  const totalPages = Math.ceil(total / LIMIT);

  if (!admin) return <AdminLogin onLogin={setAdmin} />;

  return (
    <div style={S.root}>
      <div style={S.header}>
        <div style={S.headerTitle}>HesabuSmart Admin</div>
        <button onClick={() => setShowPayments(true)} style={S.btnSm('#10b981')}>Historia ya Malipo</button>
        <span style={{ fontSize: 11, color: '#64748b' }}>{admin.name}</span>
        <button onClick={logout} style={S.btnGhost}>Toka</button>
      </div>
      <div style={S.main}>
        <div style={S.statsGrid}>
          {[
            { label: 'Maduka Yote', val: total, accent: '#38bdf8' },
            { label: 'Active', val: stats.active_shops, accent: '#10b981' },
            { label: 'Kwenye Jaribio', val: stats.on_trial, accent: '#0ea5e9' },
            { label: 'Jaribio Limeisha', val: stats.trial_expired, accent: '#ef4444' },
            { label: 'Paid', val: stats.paid_shops, accent: '#6366f1' },
            { label: 'Mpya (Mwezi)', val: stats.new_this_month, accent: '#f59e0b' },
          ].map(({ label, val, accent }) => (
            <div key={label} style={{ ...S.statCard, borderLeft: `3px solid ${accent}` }}>
              <div style={{ ...S.statVal, color: accent }}>{val !== undefined ? val : '—'}</div>
              <div style={S.statLabel}>{label}</div>
            </div>
          ))}
        </div>
        {showAddShop&&(
          <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.7)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center',padding:16}}>
            <div style={{background:'#1e293b',borderRadius:16,padding:32,width:'100%',maxWidth:480,border:'1px solid #334155'}}>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:24}}>
                <div style={{fontSize:18,fontWeight:800,color:'#e2e8f0'}}>Ongeza Duka Jipya</div>
                <button onClick={()=>setShowAddShop(false)} style={{background:'none',border:'none',color:'#94a3b8',fontSize:20,cursor:'pointer'}}>✕</button>
              </div>
              {addError&&<div style={{background:'#450a0a',border:'1px solid #ef4444',borderRadius:8,padding:'10px 14px',marginBottom:16,fontSize:13,color:'#fca5a5'}}>{addError}</div>}
              {[['jina_duka','Jina la Duka *','Jewel Store Arusha'],['jina_mmiliki','Jina la Mmiliki *','Beatrice Mary'],['email','Barua Pepe','beatrice@gmail.com'],['simu','Simu','0759630331'],['mahali','Mahali','Arusha'],['password','Nywila ya Awali *','Hesabu2024x']].map(([k,l,ph])=>(
                <div key={k} style={{marginBottom:12}}>
                  <label style={{fontSize:11,fontWeight:700,color:'#94a3b8',display:'block',marginBottom:4,textTransform:'uppercase',letterSpacing:.6}}>{l}</label>
                  <input type={k==='password'?'password':'text'} value={addForm[k]} placeholder={ph}
                    onChange={e=>setAddForm(f=>({...f,[k]:e.target.value}))}
                    style={{width:'100%',padding:'10px 14px',background:'#0f172a',border:'1px solid #334155',borderRadius:8,color:'#e2e8f0',fontSize:14,outline:'none',boxSizing:'border-box'}}/>
                </div>
              ))}
              <div style={{marginBottom:16}}>
                <label style={{fontSize:11,fontWeight:700,color:'#94a3b8',display:'block',marginBottom:4,textTransform:'uppercase',letterSpacing:.6}}>Mpango</label>
                <select value={addForm.plan} onChange={e=>setAddForm(f=>({...f,plan:e.target.value}))}
                  style={{width:'100%',padding:'10px 14px',background:'#0f172a',border:'1px solid #334155',borderRadius:8,color:'#e2e8f0',fontSize:14,outline:'none'}}>
                  <option value="trial">Trial (Siku 14)</option>
                  <option value="paid">Paid</option>
                  <option value="free">Free</option>
                </select>
              </div>
              <button disabled={addLoading} onClick={async()=>{
                setAddLoading(true);setAddError('');
                try{
                  await apiFetch('/ongeza-duka',{method:'POST',body:addForm});
                  setShowAddShop(false);
                  loadShops();
                  loadStats();
                }catch(e){setAddError(e.message);}
                setAddLoading(false);
              }} style={{width:'100%',padding:'12px',background:addLoading?'#334155':'#0891b2',color:'white',border:'none',borderRadius:8,cursor:addLoading?'not-allowed':'pointer',fontWeight:700,fontSize:15}}>
                {addLoading?'Inaongeza...':'Hifadhi Duka'}
              </button>
            </div>
          </div>
        )}
        <div style={S.tableWrap}>
          <div style={S.tableHeader}>
            <div style={{display:'flex',alignItems:'center',gap:12}}>
              <div style={S.tableTitle}>Maduka Yaliyosajiliwa</div>
              <button onClick={()=>{setAddForm({jina_duka:'',jina_mmiliki:'',email:'',simu:'',mahali:'',password:'',plan:'trial'});setAddError('');setShowAddShop(true);}}
                style={{padding:'7px 16px',background:'#0891b2',color:'white',border:'none',borderRadius:8,cursor:'pointer',fontWeight:700,fontSize:13,whiteSpace:'nowrap'}}>
                + Ongeza Duka
              </button>
            </div>
            <input placeholder="Tafuta duka, mmiliki, email..." value={search}
              onChange={e => setSearch(e.target.value)} style={S.searchInput} />
            <select value={planFilter} onChange={e => { setPlanFilter(e.target.value); setPage(1); }} style={S.select}>
              <option value="">Mpango Wote</option>
              <option value="trial">Trial</option>
              <option value="paid">Paid</option>
              <option value="free">Free</option>
              <option value="suspended">Suspended</option>
            </select>
          </div>
          {error && <div style={{ ...S.errBox, margin: 16 }}>{error}</div>}
          <div style={{ overflowX: 'auto' }}>
            <table style={S.table}>
              <thead>
                <tr>
                  {['Duka', 'Mmiliki', 'Mawasiliano', 'Mpango', 'Mauzo', 'Mapato (TZS)', 'Hali', 'Tarehe', ''].map(h => (
                    <th key={h} style={S.th}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr><td colSpan={9} style={{ ...S.td, textAlign: 'center', color: '#475569', padding: 40 }}>Inapakua...</td></tr>
                ) : shops.length === 0 ? (
                  <tr><td colSpan={9} style={{ ...S.td, textAlign: 'center', color: '#475569', padding: 40 }}>Hakuna maduka</td></tr>
                ) : shops.map(shop => {
                  const st = trialStatus(shop);
                  return (
                    <tr key={shop.id} style={{ cursor: 'pointer' }}
                      onMouseEnter={e => e.currentTarget.style.background = '#0f172a'}
                      onMouseLeave={e => e.currentTarget.style.background = ''}>
                      <td style={S.td}>
                        <div style={{ fontWeight: 600, color: '#f1f5f9', fontSize: 13 }}>{shop.name}</div>
                        <div style={{ fontSize: 10, color: '#475569' }}>{shop.location || '—'}</div>
                      </td>
                      <td style={S.td}><div style={{ fontSize: 12, color: '#94a3b8' }}>{shop.owner_name}</div></td>
                      <td style={S.td}>
                        <div style={{ fontSize: 11, color: '#94a3b8' }}>{shop.email}</div>
                        <div style={{ fontSize: 11, color: '#475569' }}>{shop.phone || '—'}</div>
                      </td>
                      <td style={S.td}><span style={S.badge(st.color, st.bg)}>{st.label}</span></td>
                      <td style={S.td}><span style={{ fontSize: 13, fontWeight: 600, color: '#cbd5e1' }}>{fmt(shop.jumla_mauzo)}</span></td>
                      <td style={S.td}><span style={{ fontSize: 13, fontWeight: 600, color: '#34d399' }}>{fmt(shop.jumla_mapato)}</span></td>
                      <td style={S.td}>
                        <span style={S.badge(shop.is_active ? '#10b981' : '#ef4444', shop.is_active ? '#d1fae5' : '#fee2e2')}>
                          {shop.is_active ? 'Active' : 'Inactive'}
                        </span>
                      </td>
                      <td style={S.td}><span style={{ fontSize: 11, color: '#475569' }}>{fmtDate(shop.created_at)}</span></td>
                      <td style={S.td}>
                        <div style={{display:'flex',gap:4}}>
                          <button onClick={() => setSelectedShop(shop)} style={S.btnSm('#334155')}>Fungua</button>
                          <button onClick={() => setPaymentShop(shop)} style={S.btnSm('#10b981')}>Lipa</button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          {totalPages > 1 && (
            <div style={{ padding: '12px 20px', display: 'flex', gap: 8, justifyContent: 'flex-end', borderTop: '1px solid #334155' }}>
              <button onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1} style={S.btnGhost}>Awali</button>
              <span style={{ fontSize: 12, color: '#64748b', padding: '6px 12px' }}>Ukurasa {page} / {totalPages}</span>
              <button onClick={() => setPage(p => Math.min(totalPages, p + 1))} disabled={page === totalPages} style={S.btnGhost}>Mbele</button>
            </div>
          )}
        </div>
      </div>
      {paymentShop && (
        <PaymentModal shop={paymentShop} onClose={() => setPaymentShop(null)}
          onSuccess={() => { fetchShops(); setPaymentShop(null); }} />
      )}
      {showPayments && <PaymentsPanel onClose={() => setShowPayments(false)} />}
      {selectedShop && (
        <ShopModal shop={selectedShop} onClose={() => setSelectedShop(null)}
          onRefresh={() => { fetchShops(); setSelectedShop(null); }} />
      )}
    </div>
  );
}
